export default function LeftArrowIcon() {
	return (
		<svg
			width="21"
			height="31"
			viewBox="0 0 21 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_647_893)">
				<path
					d="M16.3967 1.26947C16.2302 1.10154 16.032 0.968254 15.8137 0.877294C15.5953 0.786333 15.3612 0.739502 15.1246 0.739502C14.8881 0.739502 14.6539 0.786333 14.4356 0.877294C14.2173 0.968254 14.0191 1.10154 13.8526 1.26947L4.89423 10.2278C4.7263 10.3944 4.59301 10.5925 4.50205 10.8109C4.41109 11.0292 4.36426 11.2634 4.36426 11.4999C4.36426 11.7364 4.41109 11.9706 4.50205 12.1889C4.59301 12.4073 4.7263 12.6054 4.89423 12.772L13.8526 21.7303C14.0191 21.8982 14.2173 22.0315 14.4356 22.1225C14.6539 22.2135 14.8881 22.2603 15.1246 22.2603C15.3612 22.2603 15.5953 22.2135 15.8137 22.1225C16.032 22.0315 16.2302 21.8982 16.3967 21.7303C16.5647 21.5637 16.6979 21.3656 16.7889 21.1473C16.8799 20.9289 16.9267 20.6947 16.9267 20.4582C16.9267 20.2217 16.8799 19.9875 16.7889 19.7692C16.6979 19.5509 16.5647 19.3527 16.3967 19.1861L8.69256 11.4999L16.3967 3.81364C16.5647 3.64708 16.6979 3.44892 16.7889 3.23059C16.8799 3.01226 16.9267 2.77808 16.9267 2.54156C16.9267 2.30504 16.8799 2.07086 16.7889 1.85252C16.6979 1.63419 16.5647 1.43603 16.3967 1.26947Z"
					fill="#333333"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_647_893"
					x="0.364258"
					y="0.739502"
					width="20.5625"
					height="29.5208"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_647_893"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_647_893"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
}
